<template>
    <DCard
        padding
    >
        <Form
            :set-limit-settings="setLimitSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import Form from '~@/Components/Settings/Permissions/SetLimitSettings/Form'

defineProps({
    setLimitSettings: {
        type: Object,
        default () {
            return {}
        }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})

function submitData (form) {
    form.post(route('settings.permissions-set-limits.store'))
}
</script>

<style scoped>

</style>
